<template>
  <div class="main">
    <van-tabs v-model="checked" color="#3385ff" title-active-color="#3385ff" title-inactive-color="#333333" @change="tabChange">
      <van-tab title="投保须知">
        <div class="htmlStyle">
          <div class="content">
            <p>一、<span class="bold">产品基本信息</span></p>
            <p class="center mb6 lh150">
              <span class="bold">保险产品：《平安产险公路货物运输承运人责任保险条款》产品注册号为：05CA2025000170292和《平安附加国内公路货物运输盗抢险条款》产品注册号为：09AD2018000170175。</span
              >本产品由平安财产保险有限公司河北分公司（简称"平安产险河北分"）承保，面向全国区域进行销售。保险合同订立的方式：用户在购买商品时签署。
            </p>

            <p class="indent mt14 mb14 bold">
              <span class="red">本保险产品线下为您提供电子保单，但每次申报运输保险时不提供保单，只提供保险申报单，客户根据申报单和电子保单向保险公司索赔；</span
              >根据《中华人民共和国合同法》第十一条规定，数据电文是合法的合同的表现形式。如需纸质保单和发票，请致电平安客服电话：【95511】，您需提供寄送地址以便我司向您寄送，相应的快递费用将由您承担。
            </p>

            <p class="bold">二、保险期限</p>
            <p class="indent mb8 bold">
              保险人承担责任期间自货物离开起运地发货人的最后一个仓库或储运处所时起，至收货人在当地的第一个仓库或储存处所时终止。注意事宜：本保险为单次物流责任险保单，一旦购买不能退保（《中华人民共和国保险法》第五十条
              货物运输保险合同和运输工具航程保险合同，保险责任开始后，合同当事人不得解除合同）。
            </p>

            <p class="bold mb8">三、赔偿限额与首次充值的关系</p>
            <p class="indent mb8 bold">本保单为预约充值消费型保险产品，每次单次最高保额为300万；</p>

            <p class="bold">四、运输范围：全国各大城市之间（港澳台地区除外）</p>

            <p class="bold">五、免赔：</p>
            <p class="bold">本保险针对不同的货物品类免赔额不同，具体如下：</p>
            <ol>
              <li class="lh20">普通货物和易碎易损品：每次事故绝对免赔5000元或损失金额的15%，以高者为准；</li>
              <li class="lh20">散货（无规则包装货物）：每次事故绝对免赔5000元或损失金额的15%，以高者为准；</li>
              <li>生鲜及冷藏品：每次事故绝对免赔3000元或损失金额的20%，以高者为准。</li>
            </ol>

            <p class="bold">六、承保标的:</p>
            <p class="bold lh20">1、本保单承保普通货物，但客户选择运输货物为普通货物时，下述标的除外：</p>
            <p class="bold">1）新鲜水果、新鲜蔬菜、鲜花、鲜活动植物；</p>
            <p class="bold">2）大宗散货（包括散装的农产品、化工产品、油品）；各类农作物、粮食类货物（包括但不限于花生、大蒜、葵花籽、线麻籽、豆粕、鱼粉、非袋装白糖、葫芦籽）；棉包；</p>
            <p class="bold">3）疫苗、针剂、液体药品、试剂、血液制品</p>
            <p class="bold">
              4）工艺品（包括各类雕刻、编织、艺术品、刺绣、古董、字画、瓷器、玉雕及其他玉石制品等）、现金、有价证券、珠宝、具有收藏价值的货物以及计算机软件等难以客观确定保险价值的货物；
            </p>
            <p class="bold">5）大型港口机械设备、大型铸件、风力发电相关设备、商品车整车及发动机、变速器、车架、车壳以及新能源车电池组、航空器、游艇、船舶及有关运输设备、武器、弹药及其零配件；</p>
            <p class="bold">
              6）精密仪器（精密仪器的判断条件是:A.对运输有特别的防震动、防倾斜、防尘等特殊要求。B.受国内维修能力所限，设备受损后无法在国内修复。C.单件货物保额超过RMB200万元。满足上述条件之一的即为精密设备或仪器）；
            </p>
            <p class="bold">7） 红木家具、进口家具;</p>
            <p class="bold">8）新鲜水果、新鲜蔬菜、鲜花、鲜活动植物;</p>
            <p class="bold">9）任何冷藏、冷冻及温控货物；易碎货物；</p>
            <p class="bold">10）铝卷、纸卷</p>
            <p class="bold">11） 任何被保险人不具承运资质的标的</p>

            <p class="bold lh20">2、本保单承保散货（无规则包装货物），但仅承保下述列明标的的保险责任，保险标的：仅指煤炭/钢材/矿石/水泥/化肥/粮食，其他标的发生保险事故，保险人不负责赔偿。</p>

            <p class="bold lh20">
              3、本保单承保易碎易损品，本保单仅承保下述列明标的的保险责任，保险标的：陶瓷、瓷砖及其制品（工艺品除外）；大理石、石料及其制品（工艺品除外）；砖、瓦、砌块；玻璃/陶瓷瓶装酒水饮料；液晶面板/屏、钟表；手机、电脑、液晶电视、液晶显示器、平板电脑、数码相机以及其他电子3c产品、太阳能面板、光伏产品、太阳能组件、半导体、硅晶片（单硅晶片、多硅晶片），玻璃制品（平板玻璃原片除外）。
            </p>

            <p class="bold lh20">4、本保单承保散货生鲜及冷藏品，但仅承保蔬菜水果、冷藏（冷冻肉产品）、生鲜食品，不含西瓜和番茄。</p>

            <p class="bold">七、特别约定:</p>
            <p class="ml18 bold red-bg">1、投保人/被保险人需保证货物于运单或货物运输合同载明的起运地起运前投保，否则保险人不承担保险责任。</p>
            <p class="ml18 bold">
              2、责任期间： 保险责任自签发保险凭证和保险货物运离起运地发货人的最后一个仓库或储运 处所时起，至该保险凭证上注明的目的地的收货人在当地的第一个仓库或储存 处所时终止。
            </p>
            <p class="ml18 bold">3、投保人保证如实申报货物类别及品名，如投保人未如实申报，保险人不承担保险责任并在出险后有权拒绝赔付。</p>
            <p class="ml18 bold">4、对于裸装货物，锈蚀、氧化、变色、弯折、刮擦为除外责任。</p>
            <p class="ml18 bold">5、对于二手货、旧器材、退运原产地修复的已受损货物货物，本保单仅负责赔偿被保险货物遭受意外交通事故造成的货物损失。</p>
            <p class="ml18 bold">6、本保险不覆盖任何形式的仓储期间的损失。</p>
            <p class="ml18 bold">7、在任何情况下，保险人不对被保险人承运的"不承保货物"的损失进行认定和赔付，也不对"不承保货物"造成的其他货物的损失进行认定和赔付。</p>
            <p class="ml18 bold">8、凡在中华人民共和国境内合法从事物流业务的个人，也可作为本保险合同的被保险人。</p>
            <p class="ml18 bold">
              9、承运前需取得承运工具的道路运输许可证、经检验合格的车辆行驶证、具备相应驾驶资质车辆驾驶证，所有运输货物及承运工具必须符合国家或其主管部门关于安全运输的各项法律、法规，因被保险人未履行上述审核义务所造成的事故，保险人不承担保险责任。
            </p>
            <p class="ml18 bold">10、每一被保险人限投一份，多投无效。</p>
            <p class="ml18 bold">11、对于水泥、粮食及化肥，本保险不承担淡水雨淋、霉变及结块损失。</p>
            <p class="ml18 bold">12、不具备危险品运输资质的车辆承运易燃易爆品等危险品导致的任何损失不在本保单的责任范围内。</p>
            <p class="ml18 bold">13、 以下为本保单仅承保火灾/爆炸及运输工具发生碰撞、倾覆事故造成损失的货物：冷藏品，易碎货物，进口转内陆运输货物。</p>
            <p class="ml16 bold">
              14、手机、电脑、液晶电视、液晶显示器、平板电脑、数码相机以及其他电子3c产品、太阳能面板、光伏产品、太阳能组件、半导体、硅晶片（单硅晶片、多硅晶片）仅承保火灾、爆炸、交通工具意外事故导致的损失。
            </p>

            <p class="bold">八、保证条款:</p>
            <p class="bold">在物流业务的经营过程中，被保险人保证恪尽遵守以下义务，如违反，保险人不承担保险责任：</p>
            <p class="bold">1）发生保险事故后，被保险人保证积极履行减损及抗辩义务，在向第三方作出赔偿承诺之前取得保险人的同意。</p>
            <p class="bold">2）被保险人必须是有营运资质的专业承运人且保证货物经过专业化包装。</p>
            <p class="bold">3）对于公路运输，被保险人保证使用集装箱卡车或全封闭货车或用雨布全覆盖并用绳索有效扎紧的能适用于长途运输的卡车进行运输。</p>
            <p class="bold">4）承运车辆必须符合道路/桥梁/隧道/立交桥/限宽门（桩）等等各类道路设施的通行规定或要求，否则因此造成的任何损失均为除外责任。</p>
            <p class="bold">
              5）整车神秘失踪（司机、车辆、货物同时失踪）、整车遭遇盗抢（车辆、 货物同时被盗窃或抢劫，或因承运车辆被盗造成的货物损失）、货物遭遇
              哄抢、货物或承运车辆遭受恶意破坏、实际承运人道德风险、无人看管情 况下的存车过夜过程中的损失均不属于保单覆盖范围。
            </p>
            <p class="bold">6）盗窃、抢劫案件的保单责任认定，必须出具警方的立案证明。</p>
            <p class="bold">
              7） 权益转让：货物发生保险责任范围内的损失，如果根据法律规定或者有关约 定，应当由其他第三者负责赔偿部分或全部损失的，被保险人应首先向其他
              第三者索赔。如被保险人提出要求，保险人也可以先予赔偿，但被保险人应 签发权益转让书给保险人，并协助保险人向责任方追偿。
            </p>

            <p class="bold">九、在线投保流程</p>
            <p class="bold red">
              1、投保与理赔：本产品非互联网保险产品，客户在本产品页录入信息仅为数据收集，不在线上出具电子保单，电子保单由线下客服人员安排出具，出具完成后销售人员会将电子保单转发给客户，客户在本平台申报运输信息；出险后，客户凭电子保单和天津华盛保险经纪出具的申报单向保险公司索赔；
            </p>
            <p>
              2.退保/批改：<span class="bold">单次货运申报，在货运起运后不可进行退保；</span
              >预约保单退保投保人拨打平安保险客服电话95511转5提出退保/批改的申请，保险公司审核是否符合退保/批改条件，若符合条件且资料齐全，退保保费会退还至投保人名下指定银行卡。
            </p>

            <p class="bold">十、理赔服务</p>
            <p class="bold">保险标的出险后，投保人/被保险人应在24小时之内通知保险公司。</p>
            <p>1、理赔流程</p>
            <p>报案:</p>
            <p>①电话报案：95511；</p>
            <p>所需材料：</p>
            <p class="ml18">1、运单/运输合同/驾照行驶证</p>
            <p class="ml18">2、事故情况说明</p>
            <p class="ml18">3、交通事故认定书/消防事故认定书</p>
            <p class="ml18">4、承保标的的总价值证明（销售合同、出库单、发票）</p>
            <p class="ml18">5、受损货物的价值证明</p>
            <p class="ml18">6、货主对被保险人的索赔函</p>
            <p>②APP端报案：</p>
            <p>所需材料：同95511报案</p>

            <p class="bold">十一、偿付能力提示：</p>
            <p>
              请您详细了解本公司在电子投保提示书、公司官网等地方披露的最近季度的综合偿付能力充足率、风险综合评级信息及偿付能力充足率是否达到了监管要求，该信息可以作为您决定是否投保的参考信息。我司偿付能力信息查询网址为：http://property.pingan.com/gongkaixinxipilu/changfunenglixinxipilubaogao.shtml
            </p>
          </div>
        </div>
      </van-tab>
      <van-tab title="免责条款">
        <div class="htmlStyle">
          <div style="padding: 20px 5vw; height: 82vh">
            <p style="margin: 0pt 0pt 7.8pt; orphans: 0; text-align: center; widows: 0">
              <span style="font-family: 宋体; font-size: 18pt">免责说明</span>
            </p>
            <p style="margin: 0pt 0pt 7.8pt; orphans: 0; text-align: center; widows: 0">
              <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold">责任免除</span>
            </p>
            <p style="margin: 0pt 0pt 7.8pt; orphans: 0; text-align: justify; text-indent: 24pt; widows: 0">
              <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold">第五条 </span
              ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold">出现下列任一情形时，保险人不负责赔偿：</span>
            </p>
            <p style="margin: 0pt 0pt 7.8pt; orphans: 0; text-align: justify; text-indent: 24pt; widows: 0">
              <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold">（一）被保险人自有的运输或装卸工具不适合运输或装载物流货物；</span>
            </p>
            <p style="margin: 0pt 0pt 7.8pt; orphans: 0; text-align: justify; text-indent: 24pt; widows: 0">
              <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold">（二）被保险人自有的仓库不具备储存物流货物的</span
              ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold">条件。</span>
            </p>
            <p style="margin: 0pt 0pt 7.8pt; orphans: 0; text-align: justify; text-indent: 24pt; widows: 0">
              <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold">第六条</span
              ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"> 下列原因造成的损失、费用和责任，保险人不负责赔偿：</span>
            </p>
            <p style="margin: 0pt 0pt 7.8pt; orphans: 0; text-align: justify; text-indent: 24pt; widows: 0">
              <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold">（一）投保人、被保险人及其代表的故意行为或重大过失；</span>
            </p>
            <p style="margin: 0pt 0pt 7.8pt; orphans: 0; text-align: justify; text-indent: 24pt; widows: 0">
              <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold">（二）战争、敌对行动、军事行为、武装冲突、罢工、骚乱、暴动、恐怖活动；</span>
            </p>
            <p style="margin: 0pt 0pt 7.8pt; orphans: 0; text-align: justify; text-indent: 24pt; widows: 0">
              <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold">（三）核辐射、核爆炸、核污染及其他放射性污染；</span>
            </p>
            <p style="margin: 0pt 0pt 7.8pt; orphans: 0; text-align: justify; text-indent: 24pt; widows: 0">
              <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold">（四）大气污染、土地污染、水污染及其他各种污染；</span>
            </p>
            <p style="margin: 0pt 0pt 7.8pt; orphans: 0; text-align: justify; text-indent: 24pt; widows: 0">
              <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold">（五）行政行为或司法行为；</span>
            </p>
            <p style="margin: 0pt 0pt 7.8pt; orphans: 0; text-align: justify; text-indent: 24pt; widows: 0">
              <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold">（六）自然灾害；</span>
            </p>
            <p style="margin: 0pt 0pt 7.8pt; orphans: 0; text-align: justify; text-indent: 24pt; widows: 0">
              <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold">（七）公共供电、供水、供气及其他的公共能源中断；</span>
            </p>
            <p style="margin: 0pt 0pt 7.8pt; orphans: 0; text-align: justify; text-indent: 24pt; widows: 0">
              <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"
                >（八）物流货物设计错误、工艺不善、本质缺陷或特性、自然渗漏、自然损耗、自然磨损、自燃或由于自身原因造成腐烂、变质、伤病、死亡等自身变化；</span
              >
            </p>
            <p style="margin: 0pt 0pt 7.8pt; orphans: 0; text-align: justify; text-indent: 24pt; widows: 0">
              <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold">（九）物流货物包装不当，或物流货物包装完好而内容损坏或不符，或物流货物标记错制、漏制、不清；</span>
            </p>
            <p style="margin: 0pt 0pt 7.8pt; orphans: 0; text-align: justify; text-indent: 24pt; widows: 0">
              <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold">（十）发货人或收货人确定的物流货物数量、规格或内容不准确；</span>
            </p>
            <p style="margin: 0pt 0pt 7.8pt; orphans: 0; text-align: justify; text-indent: 24pt; widows: 0">
              <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold">（十一）物流货物遭受盗窃或不明原因地失踪；</span>
            </p>
            <p style="margin: 0pt 0pt 7.8pt; orphans: 0; text-align: justify; text-indent: 24pt; widows: 0">
              <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold">（十二）由于冷藏机器或隔温设备损坏而导致物流货物解冻融化后腐烂。</span>
            </p>
            <p style="margin: 0pt 0pt 7.8pt; orphans: 0; text-align: justify; text-indent: 24pt; widows: 0">
              <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold">第七条 下列物流货物的损失，保险人不负责赔偿。但由被保险人向保险人事先提出申请并经保险人书面同意的不在此限：</span>
            </p>
            <p style="margin: 0pt 0pt 7.8pt; orphans: 0; text-align: justify; text-indent: 24pt; widows: 0">
              <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold">（一）金银、珠宝、钻石、玉器、贵重金属；</span>
            </p>
            <p style="margin: 0pt 0pt 7.8pt; orphans: 0; text-align: justify; text-indent: 24pt; widows: 0">
              <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold">（二）古玩、古币、古书、古画；</span>
            </p>
            <p style="margin: 0pt 0pt 7.8pt; orphans: 0; text-align: justify; text-indent: 24pt; widows: 0">
              <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold">（三）艺术作品、邮票；</span>
            </p>
            <p style="margin: 0pt 0pt 7.8pt; orphans: 0; text-align: justify; text-indent: 24pt; widows: 0">
              <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold">（四）枪支弹药、爆炸物品；</span>
            </p>
            <p style="margin: 0pt 0pt 7.8pt; orphans: 0; text-align: justify; text-indent: 24pt; widows: 0">
              <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold">（五）现钞、有价证券、票据、文件、档案、帐册、图纸。</span>
            </p>
            <p style="margin: 0pt 0pt 7.8pt; orphans: 0; text-align: justify; text-indent: 24pt; widows: 0">
              <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold">第八条</span
              ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"> 下列损失、费用和责任，保险人不负责赔偿：</span>
            </p>
            <p style="margin: 0pt 0pt 7.8pt; orphans: 0; text-align: justify; text-indent: 24pt; widows: 0">
              <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold">（一）被保险人或其雇员的人身伤亡及其所有或管理的财产的损失；</span>
            </p>
            <p style="margin: 0pt 0pt 7.8pt; orphans: 0; text-align: justify; text-indent: 24pt; widows: 0">
              <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold">（二）被保险人应该承担的合同责任，但无合同存在时仍然应由被保险人承担的经济赔偿责任不在此限；</span>
            </p>
            <p style="margin: 0pt 0pt 7.8pt; orphans: 0; text-align: justify; text-indent: 24pt; widows: 0">
              <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold">（三）罚款、罚金及惩罚性赔偿； </span>
            </p>
            <p style="margin: 0pt 0pt 7.8pt; orphans: 0; text-align: justify; text-indent: 24pt; widows: 0">
              <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold">（四）精神损害赔偿；</span>
            </p>
            <p style="margin: 0pt 0pt 7.8pt; orphans: 0; text-align: justify; text-indent: 24pt; widows: 0">
              <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold">（五）间接损失；</span>
            </p>
            <p style="margin: 0pt 0pt 7.8pt; orphans: 0; text-align: justify; text-indent: 24pt; widows: 0">
              <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold">（六）</span
              ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold; letter-spacing: -0.3pt">投保人、被保险人在投保之前已经知道或可以合理预见的索赔情况；</span>
            </p>
            <p style="margin: 0pt 0pt 7.8pt; orphans: 0; text-align: justify; text-indent: 24pt; widows: 0">
              <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold">（七）储存在露天的物流货物的损失或费用；</span>
            </p>
            <p style="margin: 0pt 0pt 7.8pt; orphans: 0; text-align: justify; text-indent: 24pt; widows: 0">
              <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold">（八）盘点时发现的损失，或其他不明原因的短量；</span>
            </p>
            <p style="margin: 0pt 0pt 7.8pt; orphans: 0; text-align: justify; text-indent: 24pt; widows: 0">
              <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold">（九）在水路运输过程中存放在舱面上的物流货物的损失和费用，但集装箱货物不在此限；</span>
            </p>
            <p style="margin: 0pt 0pt 7.8pt; orphans: 0; text-align: justify; text-indent: 24pt; widows: 0">
              <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold">（十）发生在中华人民共和国境外的财产或费用的损失；</span>
            </p>
            <p style="margin: 0pt 0pt 7.8pt; orphans: 0; text-align: justify; text-indent: 24pt; widows: 0">
              <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold">（十一）本保险合同中载明的免赔额。</span>
            </p>
            <p style="margin: 0pt 0pt 7.8pt; orphans: 0; text-align: justify; text-indent: 24pt; widows: 0">
              <span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold">第九条</span
              ><span style="font-family: 宋体; font-size: 10.5pt; font-weight: bold"> 其他不属于本保险责任范围内的损失、费用和责任，保险人不负责赔偿。</span>
            </p>
            <p style="margin: 0pt 6.4pt 7.8pt 0pt; orphans: 0; text-indent: 24pt; widows: 0">
              <span style="font-family: 宋体; font-size: 12pt; font-weight: bold">对被保险人或其雇员的盗窃行为所导致的物流货物的损失，保险人不负责赔偿。</span>
            </p>
            <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0">
              <span style="font-family: 'Times New Roman'; font-size: 10.5pt">&#xa0;</span>
            </p>
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <div class="bottom" @click.stop="submit">我已逐页阅读并同意</div>
  </div>
</template>

<script>
import { myTrack } from "../common/track";
import { getUrlParams } from "../common/utils";

export default {
  name: "clausePage",
  data() {
    return {
      checked: 0,
      confirmdata: {},
      cargoType: "",
    };
  },
  methods: {
    submit() {
      try {
        // myTrack("须知确认页-点击阅读并同意", {
        //   产品ID: "P190005",
        //   产品名称: "优驾保UBI网络货运物责险",
        //   保险公司: "平安保险",
        //   运营渠道: getUrlParams().orderSource
        //     ? getUrlParams().orderSource
        //     : "",
        // });
      } catch (e) {}
      this.$router.push({
        path: "/insure",
        query: {
          backtrackingCode: this.$route.query.backtrackingCode,
        },
      });
    },
    showContent(type) {
      if (this.cargoType === type) {
        this.cargoType = "";
      } else {
        this.cargoType = type;
      }
    },
    tabChange(name, title) {
      myTrack("bxsc_security_details_page", {
        click_application_notes: title,
      });
    },
  },
  mounted() {
    try {
      myTrack("bxsc_security_details_page", {
        bxsc_security_details_page_visit: "页面访问",
        product_id: "P190005",
        product_name: "优驾保UBI网络货运物责险",
        product_channel: getUrlParams().orderSource ? getUrlParams().orderSource : "",
      });
    } catch (e) {
      window.console.log(e);
    }
  },
  beforeRouteEnter(to, from, next) {
    if (to.params.data) {
      next((vm) => {
        vm.confirmdata = to.params;
      });
    } else {
      next();
    }
  },
};
</script>

<style scoped lang="scss">
.main {
  background-color: #f6f5fa;
  height: 100vh;
  overflow: hidden;
}

/deep/ .van-tab--active span {
  color: #3385ff !important;
}

/deep/ .van-tabs__content {
  padding-bottom: 60px;
}

.htmlStyle {
  width: 100%;
  word-break: break-all;
  word-wrap: break-word;
  overflow-y: auto;

  .content {
    height: 82vh;
    padding: 1.49vh;
    overflow: auto;
    text-align: left;

    p {
      margin-top: 0;
      margin-bottom: 0;
      word-break: break-all;
    }
    .bold {
      font-weight: bold;
    }
    .red {
      color: #ff0000;
    }
    .red-bg {
      background-color: #ff0000;
    }
    .center {
      text-align: center;
    }
    .indent {
      text-indent: 21pt;
    }
    .ml18 {
      margin-left: 18pt;
    }
    .ml16 {
      margin-left: 15.75pt;
    }
    .mb6 {
      margin-bottom: 6pt;
    }
    .mb8 {
      margin-bottom: 7.8pt;
    }
    .mb14 {
      margin-bottom: 14pt;
    }
    .mt14 {
      margin-top: 14pt;
    }
    .lh150 {
      line-height: 150%;
    }
    .lh20 {
      line-height: 20pt;
    }
    ol {
      margin: 0;
      padding-left: 0;
    }
    ol li {
      margin-left: 15.57pt;
      padding-left: 5.68pt;
      font-size: 10.5pt;
      font-weight: bold;
    }
  }
}

.bottom {
  width: 100%;
  height: 52px;
  line-height: 52px;
  color: #ffffff;
  text-align: center;
  position: fixed;
  bottom: 0;
  left: 0;
  font-size: 17px;
  font-weight: bold;
  background-color: #3385ff;
}
</style>
